import React, { useState } from 'react';
import styled from 'styled-components';
import BookChapterTextList from '../components/BookChapterTextList';
import BookChapterTextEdit from '../components/BookChapterTextEdit';

type IProps = {
  bookChapterTextId: number;
};

const BookChapterText: React.FC<IProps> = ({ bookChapterTextId }) => {
  const [editText, setEditText] = useState(bookChapterTextId);

  const onEditText = (textId: number) => {
    setEditText(textId);
  };

  return (
    <Container>
      <BookChapterTextList onEditText={onEditText} editingTextId={editText} />
      <BookChapterTextEdit bookChapterTextId={editText} key={editText} />
    </Container>
  );
};

export default BookChapterText;

const Container = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
